import ApplicationComponent from "legacy/ApplicationComponent"
import PropTypes from "prop-types"
import React from "react"

import Modal from "src/components/Modal"

class TermsModal extends ApplicationComponent {
  constructor(props) {
    super(props)
    this.state = {
      showModal: this.props.showModal || false,
    }
    this.openModal = this.openModal.bind(this)
    this.closeModal = this.closeModal.bind(this)
  }

  openModal() {
    this.setState({ showModal: true })
  }

  closeModal() {
    this.setState({ showModal: false })
    this.handleDismiss()
  }

  handleDismiss() {
    const params = { user_id: this.props.userId }
    if (this.props.marinaSide) {
      params.marina_side = true
    }
    $.post(this.props.endpoint, params)
  }

  render() {
    return (
      <Modal
        isOpen={this.state.showModal}
        onClose={this.closeModal}
        size="mediumFixed"
      >
        <Modal.Body>
          <div className="text-sm leading-relaxed">{this.props.children}</div>
        </Modal.Body>
        <Modal.Footer
          onlyCancel
          cancelBtnText="Okay"
          onClose={this.closeModal}
        />
      </Modal>
    )
  }
}

TermsModal.propTypes = {
  showModal: PropTypes.bool,
  backdrop: PropTypes.bool,
  userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  marinaSide: PropTypes.bool,
  endpoint: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
}

export default TermsModal
